import { render, staticRenderFns } from "./list-promesa-carrito.vue?vue&type=template&id=c38c86e6"
import script from "./list-promesa-carrito.vue?vue&type=script&lang=js"
export * from "./list-promesa-carrito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports